<script>
  import AddList from "../form/AddList.svelte";
  import Validators from "../../utils/validators";
  import { days } from "../../assets/commonData";

  let formData = {
    segmentPeriodData: [],
    segmentData: [],
  };

  let fields = {
    segmentPeriodFields: [
      {
        type: "list",
        name: "day",
        items: days,
        isCheckable: false,
        label: "Day",
        readonlyValue: true,
        validations: [Validators.required("Day is required")],
      },
      {
        type: "time",
        name: "start",
        label: "Start At",
        inputClass: "w-8 !px-1",
        readonlyValue: true,
      },
      {
        type: "time",
        name: "end",
        label: "End At",
        inputClass: "w-8 !px-1",
        readonlyValue: true,
      },
    ],
    segmentFields: [
      {
        type: "text",
        name: "segmentName",
        label: "Segment Name",
        readonlyValue: true,
      },
      {
        type: "text",
        name: "segmentId",
        label: "Segment ID",
        readonlyValue: true,
      },
    ],
  };

  function onAddRow(dataObj) {
    console.log(dataObj);
    const newTrackingDetail = { ...dataObj };
    trackingData.push(newTrackingDetail);
    return trackingData;
  }

  function onDeleteRow(index) {
    console.log(index);

    trackingData.splice(index, 1);
    return trackingData;
  }
</script>

<h1 class="pb-2 text-xl font-bold">Audience Segments</h1>
<div class="flex flex-row w-full gap-2 pb-4">
  <div class="w-1/2">
    <AddList
      name="segment_period"
      fields={fields.segmentPeriodFields}
      data={formData.segmentPeriodData}
      onAddRow={(data) => onAddRow("segmentPeriodData", data)}
      onDeleteRow={(index) => onDeleteRow("segmentPeriodData", index)} />
  </div>
  <div class="w-1/2">
    <AddList
      name="targeting_segments"
      data={formData.segmentData}
      fields={fields.segmentFields}
      onAddRow={(data) => onAddRow("segmentData", data)}
      onDeleteRow={(index) => onDeleteRow("segmentData", index)} />
  </div>
</div>
